import React from 'react';

export function useStopRotatingOnFocusInsideSlide(
    ref: React.RefObject<HTMLElement>,
    setIsRotating: (value: React.SetStateAction<boolean>) => void
) {
    React.useEffect(() => {
        const handleFocus = () => {
            const refElement = ref.current as HTMLElement;

            const {activeElement} = document;

            if (!activeElement || !refElement.contains(activeElement)) return;

            setIsRotating(false);
        };

        window.addEventListener('focus', handleFocus, true);

        return () => {
            window.removeEventListener('focus', handleFocus, true);
        };
    }, [ref, setIsRotating]);
}
